var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.src)?_c('img',{staticClass:"odr-avatar",class:{
             'odr-avatar_large': _vm.size === 'l',
             'odr-avatar_medium': _vm.size === 'm',
             'odr-avatar_small': _vm.size === 's',
             'odr-avatar_xsmall': _vm.size === 'xs',
         },style:(_vm.style),attrs:{"src":_vm.src}}):_c('svg',{staticClass:"odr-avatar",class:{
             'odr-avatar_large': _vm.size === 'l',
             'odr-avatar_medium': _vm.size === 'm',
             'odr-avatar_small': _vm.size === 's',
             'odr-avatar_xsmall': _vm.size === 'xs',
         },style:(_vm.style),attrs:{"width":"80","height":"80","viewBox":"0 0 80 80","xmlns":"http://www.w3.org/2000/svg"}},[_c('title',[_vm._v("no-avatar")]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#D8D8D8","cx":"40","cy":"40","r":"40"}}),_c('path',{attrs:{"d":"M40 37c4.95 0 9-4.05 9-9s-4.05-9-9-9-9 4.05-9 9 4.05 9 9 9zm0 4.5c-6.075 0-18 2.925-18 9V55h36v-4.5c0-6.075-11.925-9-18-9z","fill":"#FFF"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }